import ProductCounter from './ProductCounter';

export default ProductCounter;
